import React from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import neverLandUtils from "../../utils/NeverLandUtils";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const ChartLine = ({ homeData, awayData, homeName, awayName }) => {
    // Home 데이터 차트
    const homeChartData = {
        labels: homeData.map((d) => d.gdate), // x축 값
        datasets: [
            {
                label: homeName,
                data: homeData.map((d) => d.value), // y축 값
                borderColor: "#f11111",
                backgroundColor: "rgb(216,100,100)",
                pointBackgroundColor: "#f11111",
                tension: 0.4,
            },
        ],
    };

    // Away 데이터 차트
    const awayChartData = {
        labels: awayData.map((d) => d.gdate), // x축 값
        datasets: [
            {
                label: awayName,
                data: awayData.map((d) => d.value), // y축 값
                borderColor: "#002aff",
                backgroundColor: "rgba(16,59,230,0.5)",
                pointBackgroundColor: "#002aff",
                tension: 0.4,
            },
        ],
    };

    // 공통 옵션
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false, // 레전드를 숨깁니다
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return `${context.dataset.label}: ${context.raw}`;
                    },
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    return (
        <div className="w-full flex flex-col justify-start bg-white">
            <span className="text-xl font-bold mb-3">승점 그래프</span>

            <div className="mb-10">
                <h3 className="text-lg font-bold mb-4 px-3 bg-red-600 text-white">{neverLandUtils.trimTeamName(homeName)}</h3>
                <Line data={homeChartData} options={options}/>
            </div>
            
            <div className="mb-7">
                <h3 className="text-lg font-bold mb-4 px-3 bg-blue-700 text-white">{neverLandUtils.trimTeamName(awayName)}</h3>
                <Line data={awayChartData} options={options}/>
            </div>
        </div>
    );
};

export default ChartLine;
